'use client';

import { FC } from 'react';
import type { Content } from '@prismicio/client';

import {
  NavigationHeading,
  NavigationHeadingProps,
} from '../../NavigationHeading/NavigationHeading';
import { ListItem } from '../../ListItem/ListItem';

import { HeaderNavigationIcon } from '@/types';

import styles from './desktopMenu.module.scss';

type Props = {
  slice: Content.NavigationSlice;
};

export const DesktopMenu: FC<Props> = ({ slice }) => {
  const isDropDownMenu = slice.primary.drop_down_links.length > 0;

  const navigationHeadingProps: NavigationHeadingProps = {
    heading: slice.primary.heading,
    isDropDownMenu,
    link: slice.primary.link,
    titleStyle: styles.menu_title,
    iconStyle: styles.icon_style,
  };

  return (
    <li
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.navigation_wrapper}
    >
      <NavigationHeading {...navigationHeadingProps} />

      {isDropDownMenu ? (
        <ul className={styles.navigation_list}>
          {slice.primary.drop_down_links.map((item, index) => {
            const tabs = 'scroll_to_products_information' in item;
            const isActiveTab = tabs && item.scroll_to_products_information;
            return (
              <ListItem
                scrollToSectionNumber={item.scroll_to_section_number ?? null}
                key={item.title}
                title={item.title}
                link={item.link}
                activeTab={isActiveTab ? index : undefined}
                icon={item.icon as HeaderNavigationIcon}
              />
            );
          })}
        </ul>
      ) : null}
    </li>
  );
};
